import AddIcon from '@mui/icons-material/Add'
import { Box, Button } from '@mui/material'
import { Link } from 'react-router'
import PageHeader from '../../components/PageHeader'
import ProjectsList from '../../components/ProjectsList'
import { useDocumentTitle } from '../../hooks/useDocumentTitle'

export default function ProjectsPage() {
  useDocumentTitle('Projects')

  return (
    <Box display="flex" flexDirection="column" flex="1">
      <PageHeader
        title="Projects"
        toolbarChildren={
          <Button component={Link} to="new" variant="contained" color="secondary" startIcon={<AddIcon />}>
            Add a Project
          </Button>
        }
      />
      <ProjectsList />
    </Box>
  )
}
